// Administration › Datasets layout (/admin/datasets, Admin only): the underline sub-tabs Grid codes · Jurisdictions & authorities · Files · Activity above the child screen; Grid codes stays current on the home, the add-grid-code wizard and the family and version pages below it.
import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";

import { RequireRole } from "@/components/common/RequireRole";
import { cn } from "@/lib/cn";

const TAB =
  "inline-flex items-center gap-2 rounded-t-sm border-b-2 border-transparent px-3.5 pt-2 pb-2.5 text-ui text-muted-foreground no-underline hover:bg-subtle";
const ACTIVE = "border-brand-red font-semibold text-foreground";
const GRID_CODE_PATHS = ["/admin/datasets/families", "/admin/datasets/new"];

export const Route = createFileRoute("/_app/admin/datasets")({
  staticData: { crumb: "Datasets" },
  component: DatasetsLayout,
});

function gridCodesCurrent(pathname: string): boolean {
  const path = pathname.replace(/\/+$/u, "");
  return (
    path === "/admin/datasets" ||
    GRID_CODE_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
  );
}

function DatasetsLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const gridCodes = gridCodesCurrent(pathname);
  return (
    <RequireRole level="A">
      <nav aria-label="Datasets" className="mx-auto flex max-w-[1440px] gap-1 border-b px-7 pt-4">
        <Link
          to="/admin/datasets"
          activeOptions={{ exact: true, includeSearch: false }}
          className={cn(TAB, gridCodes && ACTIVE)}
          activeProps={{}}
          aria-current={gridCodes ? "page" : undefined}
        >
          Grid codes
        </Link>
        <Link to="/admin/datasets/registry" className={TAB} activeProps={{ className: cn(TAB, ACTIVE) }}>
          Jurisdictions & authorities
        </Link>
        <Link to="/admin/datasets/files" className={TAB} activeProps={{ className: cn(TAB, ACTIVE) }}>
          Files
        </Link>
        <Link to="/admin/datasets/activity" className={TAB} activeProps={{ className: cn(TAB, ACTIVE) }}>
          Activity
        </Link>
      </nav>
      <Outlet />
    </RequireRole>
  );
}
